import type { ConfigurationGetCheckoutConfigsQuery } from '@/graphql/configuration/api';

export type CheckoutConfigForScope = NonNullable<
  NonNullable<ConfigurationGetCheckoutConfigsQuery['checkoutConfigs']>[number]
>;

export function findCheckoutConfigForChannel(
  configs:
    | ReadonlyArray<CheckoutConfigForScope | null | undefined>
    | null
    | undefined,
  channelSlug: string,
): CheckoutConfigForScope | undefined {
  return (
    configs?.find((config) => config?.channel === channelSlug) ?? undefined
  );
}

export function isWithdrawalScopeFromCheckoutConfig(
  configs:
    | ReadonlyArray<CheckoutConfigForScope | null | undefined>
    | null
    | undefined,
  channelSlug: string | null | undefined,
): boolean {
  if (!channelSlug) {
    return false;
  }

  const row = findCheckoutConfigForChannel(configs, channelSlug);
  return (row?.returnPeriodDays ?? 0) > 0;
}
